import type { PropNodeType } from "../../shared/types/PropGraph";
import type { PropGraphDocTreeItem, PropGraphNodeDocumentGroup } from "./types";
import { getPropGraphNodeDocumentTitle, propGraphActionNodeTypes } from "./nodeDocs";

const propGraphDocumentTreeData: PropGraphDocTreeItem[] = [
  {
    title: "道具整体设计",
    key: "overview",
    children: [
      { title: "设计目标", key: "overview-goal" },
      { title: "数据边界", key: "overview-data" },
      { title: "运行流程", key: "overview-workflow" },
    ],
  },
  {
    title: "节点设计",
    key: "nodes",
    children: [
      { title: "事件节点", key: "nodes-event" },
      { title: "目标节点", key: "nodes-target" },
      { title: "筛选节点", key: "nodes-filter" },
      { title: "取值与计算节点", key: "nodes-value" },
      { title: "条件节点", key: "nodes-condition" },
      { title: "动作节点", key: "nodes-action" },
    ],
  },
  {
    title: "端口与参数",
    key: "ports",
    children: [
      { title: "端口类型", key: "ports-types" },
      { title: "连接规则", key: "ports-connect" },
      { title: "动作参数", key: "ports-action-params" },
      { title: "校验规则", key: "ports-validation" },
    ],
  },
];

export const propGraphNodeDocumentGroups: PropGraphNodeDocumentGroup[] = [
  {
    key: "event",
    title: "事件节点",
    nodeTypes: ["eventTurnStart", "eventAcquire", "eventUse", "eventEliminated"],
  },
  {
    key: "target",
    title: "目标节点",
    nodeTypes: ["targetSelf", "targetBoard", "prototypeLibrary", "prototypeSelect"],
  },
  {
    key: "filter",
    title: "筛选节点",
    nodeTypes: ["targetFilter", "filterRarity", "filterTag", "filterPrototype", "filterRandom"],
  },
  {
    key: "value",
    title: "取值节点",
    nodeTypes: [
      "intConstant",
      "intAttribute",
      "intQuantity",
      "intKindCount",
      "intRandom",
      "floatConstant",
      "floatAttribute",
      "floatRandom",
      "rarityConstant",
      "tagConstant",
    ],
  },
  {
    key: "calculate",
    title: "计算节点",
    nodeTypes: ["intOperation", "floatOperation", "roundNumber"],
  },
  {
    key: "logic",
    title: "条件节点",
    nodeTypes: ["logicCompareInt", "logicCompareFloat", "logicContains", "logicProbability"],
  },
  {
    key: "action",
    title: "动作节点",
    nodeTypes: propGraphActionNodeTypes,
  },
];

export function createPropGraphDocumentTreeDataWithNodePages() {
  return propGraphDocumentTreeData.map((item) => (
    item.key === "nodes"
      ? {
        ...item,
        children: (item.children ?? []).map((child) => ({
          ...child,
          children: getPropGraphNodeTypesForDocumentSection(String(child.key)).map((type) => ({
            title: getPropGraphNodeDocumentTitle(type),
            key: `node:${type}`,
          })),
        })),
      }
      : item
  ));
}

export function getPropGraphNodeTypesForDocumentSection(sectionKey: string): PropNodeType[] {
  const groups = new Map(propGraphNodeDocumentGroups.map((group) => [group.key, group.nodeTypes]));
  switch (sectionKey) {
    case "nodes-event":
      return groups.get("event") ?? [];
    case "nodes-target":
      return groups.get("target") ?? [];
    case "nodes-filter":
      return groups.get("filter") ?? [];
    case "nodes-value":
      return [
        ...(groups.get("value") ?? []),
        ...(groups.get("calculate") ?? []),
      ];
    case "nodes-condition":
      return groups.get("logic") ?? [];
    case "nodes-action":
      return groups.get("action") ?? [];
    default:
      return [];
  }
}
